import type { AxiosResponse } from "axios";
import type {
  AddMessageDto,
  ChatDto,
  AdminChatFilterDto,
  MessageDto,
  UserChatFilterDto,
  SupportAdmin,
  ChatBloDto,
  ChatIdsFilterDto,
} from "@/api/api.dto";
import { ApiInstance } from "@/api";

export default class CHAT_API {
  static async addMessage(
    messageData: AddMessageDto,
  ): Promise<AxiosResponse<number>> {
    return ApiInstance.post<number>("/Chat/Add", messageData);
  }

  static async addAdminToChat(chatId: number): Promise<AxiosResponse<number>> {
    return ApiInstance.put<number>(`/Chat/AddAdminToChat/${chatId}`);
  }

  static async closeChat(chatId: number): Promise<AxiosResponse> {
    return ApiInstance.put(`/Chat/CloseChat/${chatId}`);
  }

  static async changeAdminInChat(
    chatId: number,
    newAdmin: string,
  ): Promise<AxiosResponse> {
    return ApiInstance.put(`/Chat/ChangeAdminInChat/${chatId}`, undefined, {
      params: { newAdmin },
    });
  }

  static async getAdminChats(
    filterData: AdminChatFilterDto,
  ): Promise<AxiosResponse<ChatDto>> {
    return ApiInstance.post<ChatDto>("/Chat/Chats", filterData);
  }

  static async getUserChats(
    filterData: UserChatFilterDto,
  ): Promise<AxiosResponse<ChatDto>> {
    return ApiInstance.post<ChatDto>("/Chat/UserChats", filterData);
  }

  static async getMessages(
    chatId: number,
    skip?: number,
    take?: number,
  ): Promise<AxiosResponse<MessageDto>> {
    return ApiInstance.get<MessageDto>(`/Chat/Messages/${chatId}`, {
      params: { skip, take },
    });
  }

  static async getSupportAdmins(
    skip: number = 0,
    take: number = 100,
  ): Promise<AxiosResponse<{ count: number; admins: SupportAdmin[] }>> {
    return ApiInstance.get<{ count: number; admins: SupportAdmin[] }>(
      "/Chat/Admins",
      {
        params: { skip, take },
      },
    );
  }

  static async getRequestById(
    chatId: number,
  ): Promise<AxiosResponse<ChatBloDto>> {
    return ApiInstance.get<ChatBloDto>(`/Chat/${chatId}`);
  }

  static async getExistenRequestsIds(
    filterData: ChatIdsFilterDto,
  ): Promise<AxiosResponse<number[]>> {
    return ApiInstance.post<number[]>("/Chat/ids", filterData);
  }
}
